var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { MapContent } from './styles';
import useMap from '@spa/offer/hooks/map';
import { useTranslation } from 'next-i18next';
var COORDINATES_PRECISION = 1500;
var Map = function Map(_ref) {
  var containerId = _ref.containerId,
    coordinates = _ref.coordinates,
    zoom = _ref.zoom,
    zoomSide = _ref.zoomSide,
    locked = _ref.locked,
    withoutControls = _ref.withoutControls;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useMap(zoom, coordinates, zoomSide, containerId, t);
  return __jsx(MapContent, {
    id: containerId,
    locked: locked,
    withoutControls: withoutControls
  });
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate.property_aggregate.property.location.geo,
    latitude = _ref2$offer$offerAggr.latitude,
    longitude = _ref2$offer$offerAggr.longitude;
  return {
    coordinates: {
      lng: Math.round(longitude * COORDINATES_PRECISION) / COORDINATES_PRECISION,
      lat: Math.round(latitude * COORDINATES_PRECISION) / COORDINATES_PRECISION
    }
  };
};
export default connect(mapStateToProps)(Map);